/**
 * Wait for a given amount of time
 * @param ms time to wait in milliseconds, default is 300
 * @returns
 */
export const wait = (ms: number = 300) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Sanitize a DNS label or host-like value:
 * - trim whitespace
 * - remove trailing commas (including fullwidth)
 * - strip trailing dots
 * - collapse duplicate interior dots
 */
export const sanitizeLabel = (value?: string) => {
  let v = (value || '').trim();
  v = v.replace(/[，,]+$/g, '');
  v = v.replace(/\.+$/g, '');
  v = v.replace(/\.\.+/g, '.');
  return v;
};

/**
 * Alias for sanitizing values shown in UI lists (same rules as labels)
 */
export const sanitizeValue = (value?: string) => sanitizeLabel(value);

/**
 * Run a function every N seconds
 * @param n number of seconds
 * @param fn function to run
 * @returns a function to clear the interval
 */
export const runEveryNSeconds = (n: number, fn: () => void) => {
  const interval = setInterval(fn, n * 1000);
  return () => clearInterval(interval);
};
